import React, { Component } from 'react';
import './Tabs.css';

export default class Tabs extends Component {
    constructor(props) {
        super(props);
        // active tab index
        const activeIndex = props.tabs.findIndex(({ active }) => active);
        this.state = {
            activeIndex: activeIndex >= 0 ? activeIndex : 0
        };
    }

    clickHandler = i => () => { this.setState({ activeIndex: i }); }

    render() {
        const { tabs } = this.props;
        const { activeIndex } = this.state;

        const titles = tabs.map((tab, i) => {
            console.log("tab",tab)
            return (
                <li className={`tab${i === activeIndex ? ' active' : ''}`} key={i}
                    onClick={this.clickHandler(i)}>
                    <div className='user-track-icon'>
                        <svg width="40" height="50" viewBox="0 0 38 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.8462 11.7932C24.9769 11.7932 27.5385 9.23969 27.5385 6.11875C27.5385 2.99782 24.9769 0.444336 21.8462 0.444336C18.7154 0.444336 16.1538 2.99782 16.1538 6.11875C16.1538 9.23969 18.7154 11.7932 21.8462 11.7932ZM11.3154 21.4397L4.02923 58.0681C3.65923 59.7988 5.02539 61.4443 6.81846 61.4443H7.04616C8.38385 61.4443 9.52231 60.5364 9.83539 59.2313L14.4462 38.7467L20.4231 44.4211V58.6071C20.4231 60.1676 21.7038 61.4443 23.2692 61.4443C24.8346 61.4443 26.1154 60.1676 26.1154 58.6071V42.6053C26.1154 41.0448 25.4892 39.5695 24.3508 38.4913L20.1385 34.4908L21.8462 25.9792C25.0535 29.6344 29.4443 32.0538 34.2554 32.8169C35.9631 33.0722 37.5 31.7104 37.5 29.9797C37.5 28.5895 36.4754 27.4262 35.0808 27.1992C30.7546 26.4899 27.1685 23.9364 25.2615 20.5885L22.4154 16.049C21.6467 14.8238 20.4658 13.9112 19.0839 13.4745C17.7021 13.0379 16.2094 13.1056 14.8731 13.6657L3.97231 18.262C2.94118 18.7014 2.06232 19.4331 1.44497 20.3663C0.827628 21.2995 0.499022 22.393 0.500002 23.5108V30.235C0.500002 31.7955 1.78077 33.0722 3.34616 33.0722C4.91154 33.0722 6.19231 31.7955 6.19231 30.235V23.4257L11.3154 21.4397Z" fill="#F8981C" />
                        </svg>
                    </div>
                    <div className="tab-content" key={i}
                        dangerouslySetInnerHTML={{ __html: tab.userIcon }}></div>
                    <p className='mb-0'>{tab.title}</p>
                </li>
            );
        });

        const contents = tabs.filter((tab, i) => i === activeIndex).map((tab, i) => {
            return (
                <div className="tab-content" key={i}
                    dangerouslySetInnerHTML={{ __html: tab.content }}></div>
            );
        });

        return (
            <div>
                <div className="tabs">
                    <div className="tab-content-group">{contents}</div>
                    <ul className="tab-group">{titles}</ul>
                </div>
                {/* <pre>{JSON.stringify(tabs, null, 2)}</pre> */}
            </div>
        );
    }
}
